module.exports = __webpack_public_path__ + "img/selected6-min.5e59ce1a.png";